import { ReactElement, RefObject } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

interface IProps {
  swiperRef: RefObject<HTMLDivElement>;
  catUrl: (value: string) => string;
}

const MobileBeddingSection = ({ swiperRef, catUrl }: IProps): ReactElement => {
  const { t: tMobile } = useTranslation('', {
    keyPrefix: '$pages.$home.$mobileHomePage.$beddingSection',
  });

  return (
    <section className="mobile-bedding">
      <h2
        className="heading-flexbox"
        dangerouslySetInnerHTML={{ __html: tMobile('beddingTitle') }}
      />
      <div className="bedding-swiper swiper-container" ref={swiperRef}>
        <ul className="swiper-wrapper">
          <li className="swiper-slide">
            <Link href={catUrl('theBed')} className="img-frame">
              <img
                src="/statics/img/mobile/bed.webp"
                alt={tMobile('bedImageAlt')}
                width={667}
                height={360}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
              <h3 className="subtitle">{tMobile('beddingSlide1')}</h3>
            </Link>
          </li>
          <li className="swiper-slide">
            <Link href={catUrl('linens')} className="img-frame">
              <img
                src="/statics/img/mobile/linens.webp"
                alt={tMobile('linensImageAlt')}
                width={667}
                height={360}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
              <h3 className="subtitle">{tMobile('beddingSlide2')}</h3>
            </Link>
          </li>
          <li className="swiper-slide">
            <Link href={catUrl('beddingSets')} className="img-frame">
              <img
                src="/statics/img/mobile/bedding-sets.webp"
                alt={tMobile('beddingSetsImageAlt')}
                width={667}
                height={360}
                loading="lazy"
                decoding="async"
                fetchPriority="low"
              />
              <h3 className="subtitle">{tMobile('beddingSlide3')}</h3>
            </Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default MobileBeddingSection;
